import * as actions from "../constants/userConstants";
import { Reducer } from "redux";

interface IAction {
  type: string;
  payload?: string;
}

export const userAuthReducer: Reducer = (state = {}, action: IAction) => {
  switch (action.type) {
    case actions.USER_REGISTER_REQUEST:
      return { loading: true };
    case actions.USER_LOGIN_REQUEST:
      return { loading: true };
    case actions.USER_GET_REQUEST:
      return { loading: true };
    case actions.USER_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case actions.USER_LOGIN_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case actions.USER_GET_SUCCESS:
      return { loading: false, userInfo: action.payload };
    case actions.USER_REGISTER_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_LOGIN_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_GET_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_LOGOUT_SUCCESS:
      return {};
    default:
      return state;
  }
};

export const userProfileReducer: Reducer = (state = {}, action: IAction) => {
  switch (action.type) {
    case actions.USER_PROFILE_REQUEST:
      return { loading: true, userProfile: state.userProfile };
    case actions.USER_PROFILE_UPDATE_REQUEST:
      return { updating: true, userProfile: state.userProfile };
    case actions.USER_PROFILE_REQUEST_SUCCESS:
      return { loading: false, userProfile: action.payload };
    case actions.USER_PROFILE_UPDATE_SUCCESS:
      return { loading: false, userProfile: action.payload, success: true };
    case actions.USER_PROFILE_REQUEST_ERROR:
      return { loading: false, error: action.payload };
    case actions.USER_PROFILE_UPDATE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userSubscribeReducer: Reducer = (state = {}, action: IAction) => {
  switch (action.type) {
    case actions.USER_SUBSCRIBE_REQUEST:
      return { loading: true };
    case actions.USER_SUBSCRIBE_SUCCESS:
      return { loading: false, userProfile: action.payload };
    case actions.USER_SUBSCRIBE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userForgetPasswordUpdateReducer: Reducer = (
  state = {},
  action: IAction
) => {
  switch (action.type) {
    case actions.USER_FORGET_PASSWORD_UPDATE_REQUEST:
      return { loading: true };
    case actions.USER_FORGET_PASSWORD_UPDATE_SUCCESS:
      return { loading: false, status: action.payload };
    case actions.USER_FORGET_PASSWORD_UPDATE_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
